"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLUGIN_MANAGER_CAN_OPEN_WINDOW = exports.PLUGIN_MANAGER_OPEN_WINDOW = exports.ADD_OR_UPDATE_MENUBAR = exports.ADD_OR_UPDATE_TOOLBAR = exports.FIRE_LOAD_MENUBAR = exports.FIRE_LOAD_TOOLBAR = exports.GET_OPEN_FILE_DATA = exports.KEY_DOWN_EVENT = void 0;
exports.KEY_DOWN_EVENT = 'KEY_DOWN_EVENT';
exports.GET_OPEN_FILE_DATA = 'GET_OPEN_FILE_DATA';
exports.FIRE_LOAD_TOOLBAR = 'FIRE_LOAD_TOOLBAR';
exports.FIRE_LOAD_MENUBAR = 'FIRE_LOAD_MENUBAR';
exports.ADD_OR_UPDATE_TOOLBAR = 'ADD_OR_UPDATE_TOOLBAR';
exports.ADD_OR_UPDATE_MENUBAR = 'ADD_OR_UPDATE_MENUBAR';
exports.PLUGIN_MANAGER_OPEN_WINDOW = 'PLUGIN_MANAGER_OPEN_WINDOW';
exports.PLUGIN_MANAGER_CAN_OPEN_WINDOW = 'PLUGIN_MANAGER_CAN_OPEN_WINDOW';
//# sourceMappingURL=ActionTypes.js.map